const titleToSlug = (title) =>
  title
    ? title
        .toLowerCase()
        .replace(/ /g, '-')
        .replace(/[^\w-]+/g, '')
    : '';

export default titleToSlug;
